import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './Spinner.module.scss';

const Spinner = ({
  splash,
  top,
  noPadding,
  spinnerSize,
  className,
  childrenClassName,
  withoutAnimation,
  children
}) => {
  const { t } = useTranslation('common');

  return (
    <div
      className={splash
        ? cn(styles.splash, { [styles.top]: top }, className)
        : cn(styles.spinnerWrapper, { [styles.noPadding]: noPadding }, className)
      }
    >
      {!withoutAnimation && (
        <div className={cn('spinner-border', styles.spinner)} role="status" style={{ width: spinnerSize, height: spinnerSize }}>
          <span className="sr-only">{t('loading')}</span>
        </div>
      )}
      {children && <div className={cn(styles.children, childrenClassName)}>{children}</div>}
    </div>
  );
};

Spinner.propTypes = {
  splash: PropTypes.bool,
  top: PropTypes.bool,
  noPadding: PropTypes.bool,
  spinnerSize: PropTypes.number,
  className: PropTypes.string,
  childrenClassName: PropTypes.string,
  withoutAnimation: PropTypes.bool,
};

Spinner.defaultProps = {
  splash: false,
  top: false,
  noPadding: false,
  spinnerSize: 80,
  className: null,
  childrenClassName: null,
  withoutAnimation: false,
};

export default Spinner;
